import { render, staticRenderFns } from "./ViewInbox.vue?vue&type=template&id=6afdafc6&scoped=true"
import script from "./ViewInbox.vue?vue&type=script&lang=js"
export * from "./ViewInbox.vue?vue&type=script&lang=js"
import style0 from "./ViewInbox.vue?vue&type=style&index=0&id=6afdafc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdafc6",
  null
  
)

export default component.exports